const childKeyword = (keywords) => String(keywords?.child || "Child").trim() || "Child";

const childLabel = (t, keywords) => t(childKeyword(keywords)).toLocaleLowerCase();

export const registerChildLabel = (t, keywords) => {
	const keyword = childKeyword(keywords).toLocaleLowerCase();
	return t(`register_a_${keyword}`, {
		defaultValue: t("Register a {{child}}", { child: childLabel(t, keywords) }),
	});
};

export const childNameSearchPlaceholder = (t, keywords) => {
	const keyword = childKeyword(keywords).toLocaleLowerCase();
	return t(`search_by_${keyword}_name`, {
		defaultValue: t("Search by {{child}} name", { child: childLabel(t, keywords) }),
	});
};

export const selectChildPlaceholder = (t, keywords) => {
	const keyword = childKeyword(keywords).toLocaleLowerCase();
	return t(`Select ${keyword}`, {
		defaultValue: t("Select {{child}}", { child: childLabel(t, keywords) }),
	});
};
